var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-collapse',[(_vm.search)?_c('search-list',{attrs:{"list":_vm.list,"found":_vm.found,"search-string-length":_vm.searchStringLength}}):_c('partial-list',{attrs:{"list":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }